<template>
  <div class="app-input">
    <span>{{ label }}</span>
    <input :placeholder="placeholder" v-model="model" :type="type || 'text'"/>
  </div>
</template>

<script src="./AppInput.js" />
<style scoped src="./AppInput.scss" lang="scss" />